var t=function(t){var e=t.now,r=t.collection,o=t.timeStart,a=t.frame;return e>=o+1e3?(r.push(1e3*a/(e-o)),o=e,a=0):a+=1,{timeStart:o,collection:r,frame:a}};export{t as updateFpsData};
